import "./_form-section.scss";

/**
 * One glass card grouping a related cluster of fields in a multi-section
 * form (proposal wizard, invoice/subscription "Configure" block) - the
 * design's own recurring pattern (`Proposal Builder.dc.html`: "Proposal
 * details" / "Billing address" / "Plan" / "Line items" / "Finalize" cards).
 * `title` is optional: some children (PlanProductPicker, LineItemsEditor,
 * DiscountEditor, TaxEditor, ContactsTable) already render their own `h4`
 * heading, so wrapping them here would double the title - omit `title` in
 * that case and let the child's own heading stand in for the card's.
 */
const FormSection = ({ title, children, className = "" }) => (
  <div className={`form-section ${className}`.trim()}>
    {title && <h4 className="form-section__title">{title}</h4>}
    <div className="form-section__body">{children}</div>
  </div>
);

export default FormSection;
